import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import Logo from '../../assets/images/prestige_logo.png';
import { withFirebase } from '../../config/firebase.js';
import { withNoAuthentication } from '../../config/auth.js';
import './login.css';

class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            password: '',
            error: null
        };
    }

    onUserInput = event => {
        this.setState({ [event.target.name]: event.target.value });
    }

    onUserLogin = event => {
        const { email, password } = this.state;

        if(email !== '' && password !== '') {
            this.props.firebase.auth.signInWithEmailAndPassword(email, password)
                .then(() => {
                    this.props.history.push('/');
                })
                .catch(_error => {
                    this.setState({ error: 'Wrong username or password. Try again.' });
                });
        }
        else {
            this.setState({ error: 'Please fill in all required fields.' });
        }

        event.preventDefault();
    }

    render() {
        const { email, password, error } = this.state;

        return (
            <div className='_login'>
                <form className='form' onSubmit={this.onUserLogin}>
                    <img 
                        className='logo'
                        src={Logo}
                        alt='Prestige Institute'
                    />
                    <h1 className='header'>Admin Login</h1>
                    {error && <p className='error'>{error}</p>}
                    <input 
                        className='input'
                        name='email'
                        value={email}
                        onChange={this.onUserInput}
                        type='email'
                        placeholder='Email'
                    />
                    <input 
                        className='input'
                        name='password'
                        value={password}
                        onChange={this.onUserInput}
                        type='password'
                        placeholder='Password'
                    />
                    <button className='button' type='submit'>
                        Sign in
                    </button>
                </form>
            </div>
        );
    }
}

export default compose(withRouter, withFirebase, withNoAuthentication)(Login);